require('./retailDeliveryInfoBox.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@constants
const {
    retailLoanCommons: { FORMAT_DATE_DELIVERY },
} = require('../../../../loansConstants/index');
//@utilities
const DateHelper = require('utilities/dateHelper');

const RetailDeliveryInfoBox = ({ labels, isAddress, hideDeliveryCondition }) => {
    const deliveryDate = DateHelper.formatDate(labels.deliveryDate, FORMAT_DATE_DELIVERY);

    let iconClassName = 'icon-locacion retail-delivery-info-box__icon-location';
    let labelText = labels.pickUpIn;
    let firstSectionFooterLabel = labels.concessionaire;
    let secondSectionFooter;

    if (isAddress) {
        iconClassName = 'icon-envio_rapido retail-delivery-info-box__truck';
        labelText = labels.dateEstimatedDelivery1;
        firstSectionFooterLabel = labels.dateEstimatedDelivery2;
        secondSectionFooter = (<span className="retail-delivery-info-box__content-value-date">{deliveryDate.slice(0, -1)}</span>);
    }

    return (
        <div className="retail-delivery-info-box">
            <div className={`col-md-12 col-lg-12 retail-delivery-info-box__main-content${hideDeliveryCondition ? '--delivery-hide' : ''}`}>
                <div className="retail-delivery-info-box__content-text" >
                    <i className={iconClassName} />
                    <div className="retail-delivery-info-box__content-disclaimer-text">
                        {labelText}
                    </div>
                </div>
            </div>
            <span className="retail-delivery-info-box__content-estimate-date">
                {firstSectionFooterLabel}
            </span>
            {secondSectionFooter}
        </div>

    );
}

RetailDeliveryInfoBox.propTypes = {
    isAddress: PropTypes.bool.isRequired,
    labels: PropTypes.object.isRequired,
    hideDeliveryCondition: PropTypes.bool,
};

export { RetailDeliveryInfoBox };
